<template>
  <div class="aside__item aside__item__selectable">
    <h2>{{ $t('Новости') }}</h2>
    <div class="post-short post-short_stacked">
      <div class="post-short__date">
        16.10.2018
      </div>
      <div class="post-short__title">
        <a href="/news/read/id/186">Благодарность организаторам и фототчет по MAC'2018</a>
      </div>
    </div>
    <div class="post-short post-short_stacked">
      <div class="post-short__date">
        11.07.2018
      </div>
      <div class="post-short__title">
        <a href="/news/read/id/181">Платежи на банковские карты Visa (Worldwide)</a>
      </div>
    </div>
    <div class="post-short post-short_stacked">
      <div class="post-short__date">
        02.07.2018
      </div>
      <div class="post-short__title">
        <a href="/news/read/id/178">Платежи на карты банков РФ</a>
      </div>
    </div>
    <div class="text-center">
      <a href="/news" class="btn btn-success">{{ $t('Все новости') }}</a>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'AsideNews',
  mounted() {
    this.$store.state.apiClient.call('/webapi/webapi/lastnews');
  },
  computed: {},
})
export default class AsideNews extends Vue {
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Новости": "News",
    "Все новости": "All news"
  }
}
</i18n>
